import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { header, handleError } from 'src/app/_helpers/tools/header.tool';
import { environment } from 'src/environments/environment';

export interface UvtReference {
  trm: number;
  uvt: number;
  usd50: number | null;
  usd22: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class TrmService {

  constructor(private httpClient: HttpClient) { }

  // USD equivalent of 50 UVT / 22 UVT for the header (computed by the backend
  // from the daily TRM + the yearly UVT).
  getUvtReference(): Observable<UvtReference> {
    return this.httpClient.get<UvtReference>(
      `${environment.microservices.management}trm/uvt-reference`,
      { headers: header })
      .pipe(map((res: any) => { return res; }), catchError(handleError));
  }
}
